import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { MsdAiDiscoveryTourModule } from '../../../components/msd-ai-discovery-tour/msd-ai-discovery-tour.module';
import { MsdAiShowcaseComponent } from './msd-ai-showcase.component';
import { MsdAiShowcaseRoutingModule } from './msd-ai-showcase-routing.module';

@NgModule({
  declarations: [MsdAiShowcaseComponent],
  imports: [
    CommonModule,
    MsdAiShowcaseRoutingModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    MsdAiDiscoveryTourModule,
  ],
})
export class MsdAiShowcaseModule {}
